import React, { useState } from "react";
import { Outlet } from "react-router-dom";

export default function LayoutApp() {
    return (
        <div className="layout-app">             
            <main className="main-content flex-grow-1 mb-5">    
                <Outlet />
            </main>
        </div>
    );
};
